import { Link } from 'react-router-dom';
import { useState } from 'react';

const FOOTER_FORM_URL = 'https://readdy.ai/api/form/d96dp1kut53jbls7kmv0';

const footerLinks = {
  categories: [
    { label: '网红塌房', href: '/category/wanghong-tafang' },
    { label: '明星黑料', href: '/category/mingxing-heiliao' },
    { label: '博主反差', href: '/category/bozhu-fancha' },
    { label: '每日爆料', href: '/category/meiri-baoliao' },
    { label: '全部文章', href: '/category/all' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌介绍', href: '/about' },
    { label: '联系我们', href: '/about' },
  ],
  legal: [
    { label: '隐私政策', href: '#' },
    { label: '用户协议', href: '#' },
    { label: '免责声明', href: '#' },
  ],
};

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-live-line', label: '抖音', href: '#' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subMessage, setSubMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotField = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setSubStatus('success');
      setSubMessage('订阅成功！');
      setEmail('');
      return;
    }

    setSubStatus('loading');

    try {
      const formData = new FormData(form);
      if (honeypotField) {
        formData.delete('phone_alt');
      }

      const response = await fetch(FOOTER_FORM_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setSubMessage('订阅成功！感谢关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setSubStatus('error');
        setSubMessage(serverMsg.includes('spam') ? '订阅失败，请稍后重试' : serverMsg);
      }
    } catch {
      setSubStatus('error');
      setSubMessage('网络错误，请稍后重试');
    }
  };

  return (
    <footer className="bg-foreground-950 rounded-2xl mx-4 md:mx-6 mb-6 mt-10 md:mt-14 overflow-hidden">
      <div className="relative px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-2xl font-heading font-bold text-background-50 mb-4">
              吃瓜网
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed">
              每日更新最新最热的网络爆料，网红塌房、明星黑料、博主反差视频，一站式在线吃瓜平台。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-400 hover:text-primary-400 text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              关于本站
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-foreground-400 hover:text-primary-400 text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    rel="nofollow"
                    className="text-foreground-400 hover:text-primary-400 text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              订阅每日吃瓜
            </h4>
            <p className="text-foreground-400 text-sm mb-4 leading-relaxed">
              第一时间获取最新爆料，不错过任何热点事件。
            </p>
            <form
              id="subscribe-form"
              data-readdy-form
              onSubmit={handleSubscribe}
              className="flex flex-col gap-2"
            >
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  className="flex-1 px-4 py-2.5 rounded-l-lg bg-foreground-800 text-background-50 text-sm border border-foreground-700 border-r-0 outline-none placeholder:text-foreground-500 focus:border-primary-400 transition-colors"
                  required
                />
                <button
                  type="submit"
                  disabled={subStatus === 'loading'}
                  className="px-4 py-2.5 rounded-r-lg bg-primary-500 text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center justify-center disabled:opacity-60"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
              {subStatus === 'success' && (
                <p className="text-xs text-accent-400">{subMessage}</p>
              )}
              {subStatus === 'error' && (
                <p className="text-xs text-primary-400">{subMessage}</p>
              )}
            </form>
          </div>
        </div>
      </div>

      <div className="relative px-6 md:px-12 pb-8">
        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-foreground-800/60">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 吃瓜网官网 — 版权所有
          </p>
          <p className="text-foreground-600 text-xs mt-2 sm:mt-0">
            51吃瓜网 · 91吃瓜网 · 黑料吃瓜 — 每日更新
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 flex justify-center pointer-events-none select-none">
        <span className="text-[12rem] md:text-[16rem] font-heading font-bold text-foreground-900/15 leading-none">
          吃瓜网
        </span>
      </div>
    </footer>
  );
}